import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// Ecwid's vendor JS occasionally throws a benign "nextSibling" TypeError when it
// re-renders mid-navigation; suppress it so it never surfaces to customers.
window.addEventListener(
  "error",
  (e) => {
    if (String(e.message || "").includes("nextSibling") || String(e.message || "").includes("ResizeObserver loop")) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  },
  true
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
